import getElementProperties from './get-element-properties';

/**
 * Attribútumból állítja be a hint pozícióját
 * @param element object
 * @param config object
 * @param body object
 * @param hintOptions object
 */
export default function setHintPositionFromAttribute(element, config, body, alignment) {
	angular.element(document).ready(function () {
		var elemOffset = getElementProperties(element);
		var tooltip = body.find('.hint-tooltip');
		switch (alignment) {
			case 'right':
				tooltip.css({
					top: elemOffset.top + 'px',
					left: elemOffset.left + elemOffset.width + config.paddingWidth - config.pagePadding + 'px'
				});
				tooltip.addClass('arrow-left');
				break;
			case 'left':
				tooltip.css({
					top: elemOffset.top + 'px',
					left: elemOffset.left - config.pagePadding - (config.paddingWidth + config.tooltipWidth) + 'px'
				});
				tooltip.addClass('arrow-right');
				break;
			case 'bottom-left':
				tooltip.css({
					top: elemOffset.top + elemOffset.height + config.paddingWidth + 'px',
					left: elemOffset.left - config.pagePadding + 'px'

				});
				tooltip.addClass('arrow-top-left');
				break;
			case 'bottom-right':
				tooltip.css({
					top: elemOffset.top + elemOffset.height + config.paddingWidth + 'px',
					left: elemOffset.left - config.pagePadding + 'px'

				});
				tooltip.addClass('arrow-top-right');
				break;
			case 'bottom-center':
			default:
				tooltip.css({
					top: elemOffset.top + elemOffset.height + config.paddingWidth + 'px',
					left: elemOffset.left - config.pagePadding + elemOffset.width / 2 - config.tooltipWidth / 2 + 'px'

				});
				tooltip.addClass('arrow-top-center');
		}
	});
}
